var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBtnIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9144 2.40601C30.3344 1.14592 29.1357 -0.0529389 27.8756 0.367035L1.10219 9.29161C-0.401311 9.79272 -0.354704 11.9353 1.16904 12.3706L14.1905 16.0911L17.9109 29.1126C18.3463 30.6365 20.4887 30.6831 20.9898 29.1794L29.9144 2.40601ZM27.8154 3.60606L19.4608 28.6698L15.7475 15.6737L27.8154 3.60606ZM26.6755 2.46623L14.6079 14.5339L1.61198 10.8208L26.6755 2.46623Z",
    fill: "#3F4753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBtnIcon);
export default __webpack_public_path__ + "static/media/send-btn-icon.8067744c5048c382128360ca3e9f993f.svg";
export { ForwardRef as ReactComponent };